import { useDispatch } from 'react-redux';
import { useQuery } from '@tanstack/react-query';
import { apiRequest } from '../../../../Services/Common/ApiRequest';
import Global from '../../../../Services/Common/Global';
import { useEffect } from 'react';
import { handleQuerySuccess } from '../../../../hooks/useQuriesSuccess';
import { setRowData } from '../../../../Reducer/GridReducer';
import useDeleteMutation from '../../../../hooks/apis/useDeleteMutaion';
import useSaveMutation from '../../../../hooks/apis/useSaveMutaion';
import { mapParamsBySchema, mapRowsBySchema } from '../../../../util';
import { DEP_BASIC_Schema } from './DEP_BASIC_Schema';

/**
 * 부서 목록 조회
 * @param {object} params - 조회 파라미터
 * @param {object} options - React Query 옵션 (enabled 등)
 * @returns {object} React Query result
 */
export const useSearch1 = (options = {}) => {
  const dispatch = useDispatch();
  const params = mapParamsBySchema(DEP_BASIC_Schema.mapper.search1);

  const query = useQuery({
    queryKey: ['depart', 'getDepBasicR1', params],
    queryFn: () => apiRequest('post', Global.urls.Depart.getDepBasicR1, params),
    enabled: true,
    ...options,
  });

  useEffect(() => {
    if (!query.isSuccess) return;

    handleQuerySuccess(query.data, {
      onSuccess: (rows) => {
        const filtered = (rows || []).filter((row) => {
          const v = row?.depNm1;
          return v != null && String(v).trim() !== '';
        });
        dispatch(setRowData({ gridId: 'grid1', rowData: filtered }));
      },
    });
  }, [query.isSuccess, query.data, dispatch]);

  return query;
};

/**
 * 부서 삭제
 * @param {object} options - Mutation options
 * @returns {object} Delete mutation
 */
export const useDelete1 = (options = {}) => {
  return useDeleteMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, DEP_BASIC_Schema.mapper.save1);

    return apiRequest('post1', Global.urls.Depart.deleteDepBasicD1, payload);
  }, options);
};

/**
 * 부서 저장
 * @param {object} options - Mutation options
 * @returns {object} Save mutation
 */
export const useSave1 = (context = {}, options = {}) => {
  return useSaveMutation(async (rows) => {
    const payload = mapRowsBySchema(
      rows,
      DEP_BASIC_Schema.mapper.save1,
      context
    );
    return apiRequest('post1', Global.urls.Depart.saveDepBasicU1, payload);
  }, options);
};
